module.exports = __webpack_public_path__ + "img/logo.2df6e23b.webp";